// extracted by mini-css-extract-plugin
export default {"white-button":"EventCategoryButton_white-button__4g8mx","black-button":"EventCategoryButton_black-button__n6ejG"};